import React, { useMemo } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";
import { isDefined } from "@mapmycustomers/shared/util/assert";

import Scoped from "@app/scene/dashboard/types/Scoped";
import { getTeams, getUsers } from "@app/store/members";
import { RootState } from "@app/store/rootReducer";
import { userDisplayName } from "@app/util/formatters";

import messages from "./messages";

interface Props extends Scoped {
  rank?: number;
  teams: Team[];
  users: User[];
}

const Subtitle: React.FC<Props> = ({ rank, scope, teams, users }) => {
  const intl = useIntl();
  const user = useMemo(
    () => (scope?.userId ? users.find(({ id }) => id === scope.userId) : undefined),
    [scope, users]
  );
  const team = useMemo(
    () => (scope?.teamId ? teams.find(({ id }) => id === scope.teamId) : undefined),
    [scope, teams]
  );
  const isOrgScope = !scope?.teamId && !scope.userId;
  const isTeamScope = scope?.teamId && !scope.userId;
  const unknown = <i>{intl.formatMessage(messages.unknown)}</i>;

  return (
    <div>
      {intl.formatMessage(messages.subtitle, {
        entireOrg: isOrgScope,
        name: (isTeamScope ? team?.name : user ? userDisplayName(user) : undefined) ?? unknown,
        rank,
        showRank: !isOrgScope && isDefined(rank),
        teamName: isTeamScope ? intl.formatMessage(messages.organization) : team?.name ?? unknown,
      })}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  teams: getTeams(state),
  users: getUsers(state),
});

export default connect(mapStateToProps)(Subtitle);
